import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

@Component({
  selector: 'mps-custom-snackbar',
  templateUrl: './mps-custom-snackbar.component.html',
  styleUrls: ['./mps-custom-snackbar.component.scss'],
  imports: [MatSnackBarLabel, NgClass, MatIcon, MatSnackBarActions, MatButton, MatSnackBarAction],
})
export class MpsCustomSnackbarComponent {
  snackBarRef = inject(MatSnackBarRef);
  data = inject(MAT_SNACK_BAR_DATA);

  getIconName(type: string) {
    switch (type) {
      case 'info':
        return 'info';
      case 'warning':
        return 'warning';
      case 'success':
        return 'check_circle';
      case 'error':
        return 'error';
      default:
        return 'info';
    }
  }
}
